export default __webpack_public_path__ + "static/screenhot_sample_1-bfa245f51762b07aae0e2e6b710c8a90.png";